import { TERMS_OF_REFUND_PAGE, TERMS_OF_USE_PAGE } from "@/settings/constant";
/** 결제수단 선택지. 시안상 3~4개까지 늘어날 수 있어 wrap 되는 레이아웃으로 렌더한다. */ export const BILLING_METHOD_OPTIONS = [
    {
        value: "CARD",
        label: "신용 ∙ 체크카드"
    }
];
/** 필수 동의 마스터(전체동의) 라벨 */ export const BILLING_TERMS_MASTER_LABEL = "[필수] 매월 자동 결제에 동의합니다.";
export const BILLING_TERMS = [
    {
        key: "service",
        label: "서비스 이용 약관",
        href: TERMS_OF_USE_PAGE
    },
    {
        key: "refund",
        label: "환불 규정",
        href: TERMS_OF_REFUND_PAGE
    }
];
export const BILLING_TERM_KEYS = BILLING_TERMS.map((term)=>term.key);
/**
 * 동의 이력으로 서버에 함께 보내는 약관 버전 (`POST /subscriptions`의 termsVersion).
 *
 * BILLING_TERMS의 약관 내용이 바뀌면 이 값을 올린다.
 * TODO(월구독): BE와 표기 규칙(날짜형/시맨틱)을 맞추지 않았다. 스테이징 검증 때 확정한다.
 */ export const BILLING_TERMS_VERSION = "v1";
/** 미동의 상태로 결제를 시도했을 때 노출하는 스낵바 문구 */ export const BILLING_TERMS_REQUIRED_MESSAGE = "약관에 동의해주세요.";
/**
 * 결제방법 하단 안내 문구
 *
 * 시안(Figma 2791-166004) 문구를 그대로 옮긴 것으로, 임의로 수정하지 않는다.
 *
 * TODO(월구독): 아래 두 건은 기획 재확인 후 별도 작업으로 수정 예정.
 *  1. '유의사항'과 '결제 안내'의 앞 2개 항목이 완전히 동일 (의도된 중복인지 확인 필요)
 *  2. '해지 및 환불 안내' 마지막 항목의 오타 ('환불 전차' → '환불 절차')
 *
 * TODO(월구독): '만 19세 미만 회원은 법정대리인 동의 필요'가 안내 문구에만 있고
 * 별도 동의 항목이 없다. 필수 동의로 받아야 하는지 정책 확인 필요.
 */ export const BILLING_NOTICE_SECTIONS = [
    {
        title: "유의사항",
        items: [
            "구독 요금은 매월 정기결제일에 자동으로 결제되며, 결제 완료 시 구독기간이 1개월 자동 갱신됩니다.",
            "무료 체험으로 시작한 경우, 다음 결제일 전에 미리 결제 안내를 드립니다.",
            "구독 해지는 마이쏠북에서 언제든지 가능하며, 해지 시 남은 구독기간에 대한 부분 환불은 제공되지 않습니다.",
            "만 19세 미만 회원이 유료서비스를 이용하려면 법정대리인의 동의가 필요하며, 동의 없이 체결된 이용계약은 취소될 수 있습니다."
        ]
    },
    {
        title: "결제 안내",
        items: [
            "구독 요금은 매월 정기결제일에 자동으로 결제되며, 결제 완료 시 구독기간이 1개월 자동 갱신됩니다.",
            "무료 체험으로 시작한 경우, 다음 결제일 전에 미리 결제 안내를 드립니다.",
            "정기결제일에 결제가 실패하면, 3일의 유예기간 동안 결제가 자동으로 재시도됩니다.",
            "유예기간 중에는 구독 혜택이 정상적으로 유지됩니다.",
            "유예기간 내에 결제가 완료되지 않으면 구독이 자동 해지됩니다."
        ]
    },
    {
        title: "해지 및 환불 안내",
        items: [
            "구독 해지는 마이쏠북에서 언제든지 가능합니다.",
            "다음 결제일 전날까지 해지하면 다음 달 요금이 청구되지 않습니다.",
            "해지 후에도 이미 결제한 구독기간이 끝나는 날까지 구독 혜택을 그대로 이용할 수 있습니다.",
            "해지 시 남은 구독기간에 대한 부분 환불은 제공되지 않습니다.",
            "결제 후 7일이 경과되었거나 이용권을 사용한 경우 고객센터를 통해 환불 절차를 문의해주시기 바랍니다."
        ]
    }
];
